module.exports = __webpack_public_path__ + "img/ppt.e3a8f77b.svg";